// extracted by mini-css-extract-plugin
export default {"main":"LoansPage_main__7eY++","root":"LoansPage_root__qwW38","sections":"LoansPage_sections__-uxn4","sidebar":"LoansPage_sidebar__rKyS0","loans":"LoansPage_loans__46tNb"};